module.exports = __webpack_public_path__ + "static/media/avatar-image.d961d73a.png";